import contributorRoles from "astrid-firestore/src/api/articles/constants/contributorRoles";

import useArticleContributorRolesTranslations from "./useArticleContributorRolesTranslations";

export default function useArticleContributorRolesOptions({ roles }) {
	const translations = useArticleContributorRolesTranslations();

	return [
		{
			key: "narrator",
			text: translations[contributorRoles.NARRATOR],
			value: contributorRoles.NARRATOR,
		},
		{
			key: "author",
			text: translations[contributorRoles.AUTHOR],
			value: contributorRoles.AUTHOR,
		},
		{
			key: "translator",
			text: translations[contributorRoles.TRANSLATOR],
			value: contributorRoles.TRANSLATOR,
		},
	].filter((option) => !roles || roles.includes(option.value));
}
